module.exports = __webpack_public_path__ + "static/img/guaz.57d7177b.png";